export const CHAT_ROOM_READ_EVENT = 'chat:room-read';
